import React, { FC } from 'react'

import { Routes } from 'common/constants'

import { TErrorHandler } from '../types/ErrorHandler.types'
import { useErrorHandler } from '../hooks/useErrorHandler'
import { ErrorHandlerView } from './ErrorHandlerView'

export const ErrorHandler: FC<TErrorHandler> = ({
  traceDetails,
  componentName,
  to,
  goTo = Routes.HOME,
}) => {
  const {
    replace,
    goTo: verifiedGoTo,
    to: verifiedTo,
  } = useErrorHandler({
    componentName,
    traceDetails,
    goTo,
    to,
  })

  return <ErrorHandlerView goTo={verifiedGoTo} to={verifiedTo} replace={replace} />
}
